import APIClient from '@/shared/http/clients/apitshield.js'

const APITShield = process.env.TShieldUrlApi

const SignInSSO = (data = {}, config = {}) => APIClient.post(`${APITShield}/login`, data, config)
const SignOutSSO = (data = {}, config = {}) => APIClient.post(`${APITShield}/logout`, data, config)

const TShieldRepository = {
  SignInSSO,
  SignOutSSO
}

export default TShieldRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/register/tshield.js